import {createStore, applyMiddleware, compose} from 'redux';
import thunk from "redux-thunk";
import rootReducer from '../reducers';

let applyMiddleFuncs = [thunk];
let composeEnhancers = compose;

if(process.env.NODE_ENV === 'development'){
    // applyMiddleFuncs.push(require('redux-logger').default);
    // 开发环境启动  redux-devtools  这个chrome插件
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}


function configureStore(preloadedState = {}) {
    const store = createStore(rootReducer, preloadedState, composeEnhancers(
        applyMiddleware(...applyMiddleFuncs)
    ));

    return store;
}
export default configureStore;


// WEBPACK FOOTER //
// ./client/store/store.js